import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiService } from "./api.service";
import { Response } from 'src/app/shared/models/response.model';
import { DataWithPage } from 'src/app/shared/models/data-with-page.model';
import { GeneralCategory } from "src/app/shared/models/general-category.model";

// API danh sách lĩnh vực kinh doanh
const API_GET_BUSINESS_FIELD = "/contract-employment/moha/business-field";
// API danh sách loại hình doanh nghiệp
const API_GET_BUSINESS_TYPE = "/contract-employment/moha/business-type";
// API danh sách ngành nghề
const API_GET_PROFESSION = "/contract-employment/moha/profession";
// API Lấy LOẠI danh sách HĐ/VB - nâng cấp
const API_GET_DETAIL_CONFIG_HDLD = "/enterprises/moha/config";
// API Lưu cấu hình hợp đồng lao động
const API_SAVE_CONFIG_HDLD = "/enterprises/moha/config";
// API lấy danh sách 22 tiêu chí
const API_GET_PROPERTIES = "/contract-employment/properties/get-all";
//	API Lấy danh sách Mẫu HĐLĐ
const API_DOCUMENT_TYPE_ENTERPRISES = "/dc/document-type-enterprises/get-all";
// API lấy dữ liệu dropdown của tiêu chí
const API_GET_DROP_DOWN_PROPERTIES = "/contract-employment/template-field-configs/get-all";
// API lấy dữ liệu màn tìm kiếm
const API_GET_ALL_LABOR_REPORT = "/contract-employment/document-type/filter";
// API lấy dữ liệu chi tieets
const API_GET_BY_ID_LABOR_REPORT = "/contract-employment/document-type/details";
// API thêm mới
const API_CONFIG_LINK_CONTRACT_TEMPLATE_CREATE = "/contract-employment/document-type/create";
// API chỉnh sửa
const API_CONFIG_LINK_CONTRACT_TEMPLATE_UPDATE = "/contract-employment/document-type/update";
// API xóa
const API_SYSTEM_DELETE_LABOR_REPORT = "/contract-employment/document-type/delete";


@Injectable({
  providedIn: "root",
})
export class LaborUtilizationReportService {
  constructor(private apiService: ApiService) {}

  getBusinessTypes(): Observable<Response<any>> {
    return this.apiService.get(API_GET_BUSINESS_TYPE).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getBusinessFields(): Observable<Response<any>> {
    return this.apiService.get(API_GET_BUSINESS_FIELD).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getProfessions(): Observable<Response<any>> {
    return this.apiService.get(API_GET_PROFESSION).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getDetailConfigHDLD(): Observable<Response<any>> {
    return this.apiService.get(API_GET_DETAIL_CONFIG_HDLD).pipe(
      map((res) => {
        return res;
      })
    );
  }

  saveConfigHDLD(body: any = {}): Observable<any> {
    return this.apiService.post(API_SAVE_CONFIG_HDLD, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  /**
   * Get ServiceType list
   */
   getServiceTypes(id: any): Observable<any>{
    return this.apiService.get(`/common/enterprise/service-type/${id}?isEmploymentContract=1`);
  }

  getDocumentTypeEnterprises(body: any = {isEmploymentContract: true}): Observable<Response<DataWithPage<Array<any>>>> {
    return this.apiService.post(API_DOCUMENT_TYPE_ENTERPRISES, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getInfoProperties(): Observable<Response<any>> {
    return this.apiService.get(API_GET_PROPERTIES).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getDataDropDownOfPropertie(payload: any): Observable<Response<any>> {
    return this.apiService.get(API_GET_DROP_DOWN_PROPERTIES, payload).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getLaborReportById(id: any): Observable<any>{
    return this.apiService.post(API_GET_BY_ID_LABOR_REPORT, {id: id}).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getLaborReport(body: any = {}): Observable<Response<DataWithPage<Array<any>>>> {
    return this.apiService.post(API_GET_ALL_LABOR_REPORT, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  createConfigLinkContractTemplate(body: any = {}): Observable<any> {
    return this.apiService.post(API_CONFIG_LINK_CONTRACT_TEMPLATE_CREATE, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  updateConfigLinkContractTemplate(body: any = {}): Observable<any> {
    return this.apiService.post(API_CONFIG_LINK_CONTRACT_TEMPLATE_UPDATE, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  deleteLaborReport(body: any = {}): Observable<Response<string>> {
    return this.apiService.post(`${API_SYSTEM_DELETE_LABOR_REPORT}`, body).pipe(
      map((res) => {
        return res;
      })
    );
  }
}
